// extracted by mini-css-extract-plugin
module.exports = {"container":"list-module--container--1G6IY","filters":"list-module--filters--1i7w2","select":"list-module--select--1QxmU","resource":"list-module--resource--2lr7r"};